import React from "react";
import { Redirect, Route, withRouter } from "react-router-dom";
import Layout from "containers/Layout";
import { connect } from "react-redux";
import { DASHBOARD, REDIRECT_CONFIG } from "routes/pageConfig";
import { hasJWT, hasPagePermission } from "routes/utils";
import { track } from "../../utils/analytics";

const PrivateRoute = ({
  component: Component,
  roles,
  config,
  noPadding,
  renderLayout = true,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (!hasJWT()) {
        track("DASHBOARD_LOGIN_MISSING_JWT");
        return (
          <Redirect
            to={{
              pathname: "/login",
            }}
          />
        );
      }

      if (config && !hasPagePermission(config)) {
        // let's just grab the first role that's applicable and redirect there
        const roleNames = Object.keys(roles);
        for (let i=0; i<roleNames.length; i++) {
          const key = roleNames[i];
          if (roles[key] && REDIRECT_CONFIG[key]) {
            return (
              <Redirect
                to={{
                  pathname: REDIRECT_CONFIG[key],
                }}
              />
            );
          }
        }
        return (
          <Redirect
            to={{
              pathname: DASHBOARD.path,
            }}
          />
        );
      }

      return (
        renderLayout ? (
          <Layout noPadding={noPadding}>
            <Component {...props} />
          </Layout>
        ) : (
          <Component {...props} />
        )

      );
    }}
  />
);

const mapStateToProps = (state) => ({
  roles: state.user.roles,
});

export default withRouter(connect(mapStateToProps)(PrivateRoute));
